import { AxiosRequestConfig } from "axios";
import { NoticeTalkRoomRequest } from "../../models/communityTalk/noticeTalkRoomRequest";
import ApiBase from "../apiRequestBase";

/**
 * メール通知周りのAPIへのリクエスト。
 */
export default class MailReceiveApiRequest {
	/**
	 * notice/talkroomのPOSTリクエスト
	 */
	public async postNoticeTalkRoom(tenantId: string, request: NoticeTalkRoomRequest): Promise<string> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/mail_receive/notice/talkrooms`,
			method: "POST",
			headers: {
				tenantId: tenantId,
			},
			data: request,
		};

		return (await ApiBase.requestWithApiToken<string>(tenantId, options)) as string;
	}
}
